//TABLE WITH 2 ROWS AND 2 COLUMNS (WPQ- VARIABLES AND WELDING PROCESS)

import { isAlphanumericAllSpecialCharacters } from "../../../functions/validations";

import { GenericTable } from "../../utility/common/TransactionComponents/GenericTable";


export const errorstatus = (error, columns, type) => {
  let status = false
  columns.map((column) => {
    if (column.field === 'actualValue' || column.field === 'RangeQualified') {

      if (error[`WPQ_${type}_${column.field}`]?.status) {
        status = true
      }
    }

  })
  return status
}

export const errormessage = (error, columns, type) => {
  let message = ""
  columns.map((column) => {
    if (column.field === 'actualValue' || column.field === 'RangeQualified') {
      if (error[`WPQ_${type}_${column.field}`]?.message) {
        message = error[`WPQ_${type}_${column.field}`].message
      }
    }
  })
  return message
}

export const WPQVariableTable = ({
  isReadonly,
  handleChange,
  setError,
  rowhead1,
  rowhead2,
  error,
  colhead1,
  colhead2,
  colhead3,
  name1,
  name2,
  name3,
  name4,
  name6,
  value1,
  value2,
  value3,
  value4,
  value6,
  maxLength,
  style2,
  PNoActive,
  setheaderObj,
  errorstyle,
  blyestyle,
  disableFields,
  setIsEdited,
  isAllowDashedSpecialCharacters
}) => {
  const columns = [
    {
      type: 'label',
      field: "label",
      width: '150px',

    },
    {
      header: rowhead1,
      field: 'actualValue',
      type: 'input',
      inputWidth: '350px',
      maxLength: maxLength,
      validator: isAllowDashedSpecialCharacters || isAlphanumericAllSpecialCharacters,
      className: "WpsVariableInput-md"

    },
    {
      header: rowhead2,
      field: 'RangeQualified',
      type: 'input',
      inputWidth: '350px',
      maxLength: maxLength,
      validator: isAllowDashedSpecialCharacters || isAlphanumericAllSpecialCharacters,
      className: "WpsVariableInput-md"
    },
    // ... other columns
  ];

  // let tabledata = convertToRows(headerObj)

  const tableData = {
    rows: [
      {
        label: { value: colhead1 },
        actualValue: { value: value1, field: name1, error: error[name1].status },
        RangeQualified: { value: value2, field: name2, error: error[name2].status },

        hasError: errorstatus(error, columns, "VAR_TypeofJoint"),
        errorMessage: errormessage(error, columns, "VAR_TypeofJoint")
      },
      {
        label: { value: colhead2 },
        actualValue: { value: value3, field: name3, error: error[name3].status },
        RangeQualified: { value: value4, field: name4, error: error[name4].status },

        hasError: errorstatus(error, columns, "VAR_BaseM"),
        errorMessage: errormessage(error, columns, "VAR_BaseM")
      },


      // ... other rows
    ]


  };

  const AdditionaRow = {
    rows: [
      {
        
        value: value6,
        header: colhead3,
        colSpan: 2,
        type: "dropdown",
        valueField: "wld_p_category", labelField: "wld_p_category",
        field: "WPQ_VAR_Pcategory_RangeQualified", padding: "56%",
        error: error["WPQ_VAR_Pcategory_RangeQualified"]?.status,
        hasError: error["WPQ_VAR_Pcategory_RangeQualified"]?.status,
        errorMessage: error["WPQ_VAR_Pcategory_RangeQualified"]?.message
      }]
  };

  return (
    <GenericTable
      data={tableData}
      columns={columns}
      isReadonly={isReadonly}
      handleChange={handleChange}
      setError={setError}
      AdditionalRow={AdditionaRow}
      setData={setheaderObj}
      errorStyle={errorstyle}
      defaultStyle={blyestyle}
      disableFields={disableFields}
      combinedOptions={true}
      combinedLabel={"wld_code"}
      dropdownData={{
        WPQ_VAR_Pcategory_RangeQualified: [PNoActive] // Your dropdown options here
      }}
      setIsEdited={setIsEdited}
       customColumnStyle={"text-start border thead-color"}
    />

  );
};
